import type { RowFilters, VarTabData } from "@/services/tax-closing";

export const MATCH_FIELD = "matched";
export const MATCH_VALUE_TRUE = "true";
export const MATCH_VALUE_FALSE = "false";

export type MatchFilter = "todos" | "com" | "sem";
export type MatchStatusKey = "com" | "sem" | "notComparable" | "unknown";

type MatchRow = {
  matched?: boolean | null;
  notComparableReason?: string | null;
};

export function matchStatusKey(row: MatchRow): MatchStatusKey {
  if (row.matched === undefined || row.matched === null) return "unknown";
  if (row.notComparableReason != null) return "notComparable";
  if (row.matched) return "com";
  return "sem";
}

export interface MatchFilterParams {
  filters?: RowFilters;
}

const MATCH_FILTER_PARAMS: Record<MatchFilter, MatchFilterParams> = {
  todos: {},
  com: { filters: { [MATCH_FIELD]: [MATCH_VALUE_TRUE] } },
  sem: { filters: { [MATCH_FIELD]: [MATCH_VALUE_FALSE] } },
};

export function matchFilterParams(filter: MatchFilter): MatchFilterParams {
  return MATCH_FILTER_PARAMS[filter];
}

const MATCH_FILTER_LABELS: Record<MatchFilter, string> = {
  todos: "Todos",
  com: "Com match",
  sem: "Sem match",
};

export const MATCH_FILTER_OPTIONS = Object.keys(
  MATCH_FILTER_LABELS,
) as MatchFilter[];

export function matchFilterLabel(filter: MatchFilter): string {
  return MATCH_FILTER_LABELS[filter];
}

type MatchSummary = Pick<
  VarTabData["summary"],
  "rowsWithoutMatch" | "rowsNotComparable"
>;

export function semMatchTotal(summary: MatchSummary): number {
  return summary.rowsWithoutMatch + summary.rowsNotComparable;
}

export const MATCH_REASON_NAO_LOCALIZADA = "Não localizada no GFT";
export const MATCH_REASON_SEM_CUPOM = "Sem cupom (não comparável)";

const MATCH_REASON_LABELS: Record<MatchStatusKey, string | null> = {
  sem: MATCH_REASON_NAO_LOCALIZADA,
  notComparable: MATCH_REASON_SEM_CUPOM,
  com: null,
  unknown: null,
};

export function matchReasonLabel(row: MatchRow): string | null {
  return MATCH_REASON_LABELS[matchStatusKey(row)];
}

export function hasMatchDetail(row: MatchRow): boolean {
  return matchReasonLabel(row) !== null;
}
